// extracted by mini-css-extract-plugin
export var chevron = "_mx-1";
export var clickable = "_mx-0";
export var ruleRow = "_mx-2";